/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersModule
 * Purpose		: Module for Customers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { CustomersService } from './Customers.service';
import { CustomersListComponent } from './CustomersList.component';
import { CustomersSearchComponent } from './CustomersSearch.component';
import { CustomersAddComponent } from './CustomersAdd.component';
import { CustomersEditComponent } from './CustomersEdit.component';
import { CustomersDetailsComponent } from './CustomersDetails.component';

import { CustomersRoutingModule } from './Customers-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    CustomersRoutingModule
  ],
  declarations: [
    CustomersListComponent,
	CustomersSearchComponent,
    CustomersEditComponent,
    CustomersAddComponent,
	CustomersDetailsComponent
  ],
  providers: [
    CustomersService
  ]
})

export class CustomersModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Customers/Customers.module.ts